function Description({ children, className }) {
  return (
    <p
      className={`${className} text-base text-justify`}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}

export default Description;
